<template>
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div>
                <div>
                    <!-- banner -->
                    <img class="banner" :src="`${url}20250618/${banner}.png`" alt="banner">
                    <!-- <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule"> 活动规则 </span> -->
                    <!-- <img class=" rule" @click="showRule = true" :src="`${v.url}2025-02-18/${v.ruleImg}.png`"> -->
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <!-- 获奖奖品 -->
                        <div :class="['reward', `reward${currentJobTab}`]" :style="{ backgroundImage: `url(${url}20250618/${rewardImg}.png)` }">
                        </div>
                        <!-- 达标状态 -->
                        <div v-if="showReword">
                            <img class="reward-status" :src="`${url}20250618/${dataInfo.head === '达标' ? 'get' : 'noget'}.png`">
                        </div>
                        <!-- 当前状态 -->
                        <div class="mmbMum-box" v-if="currentJobTab == 2">
                            <div>
                                已获得美美币数量
                            </div>
                            <div class="mmbMum">
                                {{ dataInfo.head }}
                            </div>
                        </div>
                        <!-- 更新时间 -->
                        <p class="update-time">数据更新时间{{ dataInfo.dateTime }}0点</p>
                    </div>
                    <div class="bg-color" :style="`background-color:${bgColor()} ;`"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <div>
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <div>
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j.dictValue }" v-for="(j, n) in jobTabs[currentJobTab - 1].groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j.dictLabel }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="myWrapper" v-if="currentJobTab == 1 ? dataInfo.cspPk : dataInfo.cspMmb">
                        <RankingItem :currentJobTab="currentJobTab" isMe :list="[myInfo]" :currentGroupTab="currentGroupTab" />
                    </div>
                    <!-- <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ jobTabs[currentJobTab - 1].title1 }}</div>
                        <div class="ranking-order" v-if="currentJobTab == 2">{{ currentJobTab == 2 && currentGroupTab == 1 ? '纳新人数' : '激励人数' }}</div>
                        <div class="ranking-bonus">{{ jobTabs[currentJobTab - 1].title3 }}</div>
                    </div> -->
                    <RankingItem :jobTabs="jobTabs" :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" />
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { Toast } from 'vant'

    export default {
        name: 'ssRankList',
        components: {
            RankingItem
        },
        computed: {
            // 排名数据
            rank() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item.rnk
                    }
                    if (this.currentJobTab == 2 && this.currentGroupTab == 1) {
                        return item.nxRnk
                    }
                    if (this.currentJobTab == 2 && this.currentGroupTab == 2) {
                        return item.saleRnk
                    }
                }
            },
            // 头图
            banner() {
                switch (this.currentJobTab) {
                    case '1':
                        return 'duidu'
                    case '2':
                        return 'meimeibi'
                    default:
                        break;
                }
            },
            //获奖奖品背景图片
            rewardImg() {
                switch (this.currentJobTab) {
                    case '1':
                        return 'duiduhuojiang'
                    case '2':
                        return 'naxinxiaoshouhuojiang'
                    default:
                        break;
                }
            },
            // 中间背景色
            bgColor() {
                return function () {
                    switch (this.currentJobTab) {
                        default: '#F3D690'
                            break;
                    }
                }
            },
            // list-我的数据
            myInfo() {
                switch (this.currentJobTab) {
                    case '1':
                        return this.dataInfo.cspPk
                    case '2':
                        return this.dataInfo.cspMmb

                }
            },
            showReword() {
                // 未达标且没有我的数据
                if (this.currentJobTab == 1 && (!this.dataInfo.cspPk && this.dataInfo.head === '未达标')) {
                    return false
                } else {
                    return true
                }
            }
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [
                    {
                        dictLabel: '对赌激励', dictValue: '1',
                        groupTabs: [{ dictLabel: '超声炮', dictValue: '1' }, { dictLabel: '超V脸', dictValue: '2' }],

                    },
                    {
                        dictLabel: '销售纳新激励', dictValue: '2',
                        groupTabs: [{ dictLabel: '纳新激励', dictValue: '1' }, { dictLabel: '销售激励', dictValue: '2' }],
                    }], // 职位分类标签列表
                currentJobTab: '1',
                currentGroupTab: '1', // 当前选中的分组
                loading: false, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "title1": "姓名",
                        "title2": "",
                        "title3": "销售人数",
                    },
                    {

                        "title1": "姓名",
                        "title2": "纳新人数 ",
                        "title3": "获得美美币",
                    }
                ],
                dataInfo: {},
                url: "https://staticwecom.beautyfarm.com.cn/wecom-workbench/"
            }
        },
        mounted() {
            this.getDataList()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                if (this.finished) return
                try {
                    const params = {
                        groupNo: this.currentGroupTab,
                        type: this.currentJobTab,
                        page: this.page
                    }
                    const { code, msg, data } = await request({
                        url: '/empcsp/getList',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();

                    const newArr = this.jobTabs.map((item, index) => {
                        return { ...item, ...this.themeArr[index] }
                    })
                    this.jobTabs = newArr
                    Object.assign(this.jobTabs[this.currentGroupTab - 1], data)
                    console.log(this.jobTabs)
                    // 对应jobTabs中的dataInfo赋值
                    this.dataInfo = data
                    // 对赌激励取cspPkList ，销售纳新取cspMmbList
                    const list = this.currentJobTab == 1 ? data && data.cspPkList : data && data.cspMmbList
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.page = 1
                this.finished = false
                this.error = false;
                this.getDataList()
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v.dictValue;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/serviceRankingRules', query: { currentJobTab: this.currentJobTab } })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;
    }

    .mmbMum-box {
        margin: 40px 0;

        .mmbMum {
            color: #0072FF;
            font-size: 46px;
            margin: 38px 0 40px 0;
            font-weight: bold;
        }
    }

    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        width: 120px;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: #D22E28;
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
        // padding: 10px 0;
    }

    .rule1,
    .rule2 {
        background: #DAA55F;
    }

    .rule3 {
        background: #D22E28;
    }

    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            // margin-bottom: 30px;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 349px;
        margin-bottom: 30px;
        background-size: 100% 100%;

        >div {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .reward-data {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            width: 50%;

            >img {
                height: 150px;
            }

            >div {
                font-size: 36px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            &:first-of-type {
                width: 60%;
            }
        }

        .reward-data-column {

            >div {
                font-size: 36px;
                padding-top: 10px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            img {
                height: 150px;
                vertical-align: sub;
                padding-left: 75px;
            }
        }


    }

    .reward2 {
        height: 485px;
    }


    .update-time {
        font-size: 24px;
        color: #999999;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        // display: flex;
        margin: 20px 0 30px 0;

        >div {
            display: flex;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 40px 40px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;

        &.on {
            color: #333333;

            // background-color: #DAA55F;
            // color: #ffffff;
            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
    }

    .group-tab-item {
        min-width: 22%;
        // margin-right: 30px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 3px 10px;
        margin-right: 23px;

        &.on {
            color: #ffffff;
            background-color: #DAA55F;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }


    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #F3D690;
    }

</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
            font-weight: 500;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
